<div class="flex justify-center items-center w-full h-full" (click)="close()">
  <ig-image *ngIf="data.imgs.length===1" [src]="data.imgs[0]" cls=""></ig-image>
</div>